export default "__VITE_ASSET__fd1a9c2f__"